import { DtoInclude, DtoRef } from "../../../core/store/dto/dto";
import { AccountObjectDto } from "../account-object/account-object.dto";

export class NoteDto extends AccountObjectDto {
    @DtoInclude
    content: string;
    @DtoInclude
    sensitive: boolean;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/note/note.dto.ts